import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  jwt: null,
  isAuthenticated: false,
  status: "idle",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setJwt: (state, action) => {
      state.jwt = action.payload;
      state.isAuthenticated = true;
    },
    logout: (state) => {
      state.jwt = null;
      state.isAuthenticated = false;
      state.status = "idle";
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
  },
});

export const { setJwt, logout, setStatus } = authSlice.actions;

export const logoutThunk = () => (dispatch) => {
  dispatch(logout());
  try {
    sessionStorage.removeItem("vardaan_admin_jwt");
  } catch {
    /* ignore */
  }

  // Redirect to admin entry after auth is cleared.
  if (typeof window !== "undefined" && window.location.pathname !== "/admin-dashboard") {
    window.location.assign("/admin-dashboard");
  }
};

export const selectJwt = (state) => state.auth.jwt;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAuthStatus = (state) => state.auth.status;

export default authSlice.reducer;
